// extracted by mini-css-extract-plugin
var _1 = "ContentTabs__ContentTabs--fG_XB";
export { _1 as "ContentTabs" }
